/**
 * API Gateway configuration for different environments.
 *
 * Each environment has its own API Gateway deployment:
 * - dev: Original API Gateway (created 2025-05-23)
 * - demo: Separate API Gateway (created 2026-01-23)
 */

interface ApiConfig {
  draftContentBlocks: string;
  // Add other API endpoints here as needed
}

const API_CONFIG: Record<string, ApiConfig> = {
  dev: {
    draftContentBlocks:
      'https://2336ny2cpe.execute-api.us-east-2.amazonaws.com',
  },
  demo: {
    draftContentBlocks:
      'https://hgsimwkg2f.execute-api.us-east-2.amazonaws.com',
  },
  // Add production config when ready
  // prod: {
  //   draftContentBlocks: 'https://xxxxxxxx.execute-api.us-east-2.amazonaws.com',
  // },
};

/**
 * Gets the API configuration for the current environment.
 * Priority: Environment variable > Config lookup > Error
 */
export const getApiConfig = (): ApiConfig => {
  const stage = import.meta.env.VITE_STAGE || 'dev';

  // Environment variable takes precedence (allows runtime override)
  const envUrl = import.meta.env.VITE_API_DRAFT_CONTENT_BLOCKS;
  if (envUrl) {
    return {
      draftContentBlocks: envUrl,
    };
  }

  // Fall back to config lookup
  const config = API_CONFIG[stage];
  if (!config) {
    throw new Error(
      `No API configuration found for stage "${stage}". ` +
        `Either set REACT_APP_API_DRAFT_CONTENT_BLOCKS or add "${stage}" to API_CONFIG.`,
    );
  }

  return config;
};

/**
 * Gets the draft content blocks API URL for the current environment.
 */
export const getDraftContentBlocksApiUrl = (): string => {
  return getApiConfig().draftContentBlocks;
};
